import dva from 'dva';
import router from './router';
import './index.css';
import vadpLogin from './models/vadpLogin';
import twoFactor from './models/twoFactor';
import resetPasssword from "./models/resetPasssword";
// 1. Initialize
const app = dva();

// 2. Plugins
// app.use({});

// 3. Model
app.model(vadpLogin);
app.model(twoFactor);
app.model(resetPasssword);
// 4. Router
app.router(router);

// 5. Start
app.start('#root');



// WEBPACK FOOTER //
// ./src/index.js